import { AVAILABLE_COMMERCE_STORES } from '@/legacy/constants/stores'
import { getLocalesByStoreCode } from '@/legacy/helpers/locale'

const baseNuxtShopifyModuleConfig = {
  options: {
    strategy: 'i18n_module',
    checkoutCookieKey: 'wild_checkout_id',
    cartCookieKey: 'wild_cart_id',
    checkoutStoreCodeCookieKey: 'wild_store_code',
  },
  stores: [
    {
      domain: 'wild-cosmetics.myshopify.com',
      originDomain: 'wild-cosmetics.myshopify.com',
      token: import.meta.env.PUBLIC_UK_SHOPIFY_STOREFRONT_TOKEN,
      handle: 'uk',
      isPrimary: true,
      locales: getLocalesByStoreCode('uk'),
    },
    {
      domain: 'wildde.myshopify.com',
      originDomain: 'wildde.myshopify.com',
      token: 'c8cfae70a082455d195beadff4a083b0',
      handle: 'eu',
      isPrimary: false,
      locales: getLocalesByStoreCode('eu'),
    },
    {
      domain: 'wildusa.myshopify.com',
      originDomain: 'wildusa.myshopify.com',
      token: 'eea86ecebbf1b7bbcc45b3c1b64ba2d2',
      handle: 'us',
      isPrimary: false,
      locales: getLocalesByStoreCode('us'),
    },
    {
      domain: 'wild-aus.myshopify.com',
      originDomain: 'wild-aus.myshopify.com',
      token: '249e240286a8ced065354881eda27c47',
      handle: 'au',
      isPrimary: false,
      locales: getLocalesByStoreCode('au'),
    },
    {
      domain: 'wild-development.myshopify.com',
      originDomain: 'wild-development.myshopify.com',
      token: '5fb8cce819cb02bd330814409ecf85b0',
      handle: 'ukDev',
      isPrimary: false,
      locales: getLocalesByStoreCode('ukDev'),
    },
    {
      domain: 'wild-us-development.myshopify.com',
      originDomain: 'wild-us-development.myshopify.com',
      token: '8572c82ce5958db309943e9a9a0fa3cf',
      handle: 'usDev',
      isPrimary: false,
      locales: getLocalesByStoreCode('usDev'),
    },
  ],
}

export const getNuxtShopifyModuleConfigs = () => {
  return {
    next: {
      ...baseNuxtShopifyModuleConfig,
      options: {
        ...baseNuxtShopifyModuleConfig.options,
        storefrontVersion: '2024-01',
        pluginVersion: '2.0',
      },
    },
  }
}

export const getStoreConfigs = () => AVAILABLE_COMMERCE_STORES
